/**
 * Shared SSE event utilities.
 *
 * Extracted from useRoundsChat.ts and pipelineManager.ts to eliminate
 * repeated event type / agent ID extraction logic.
 */

import type { CasePanelSSEEvent } from '../services/backendAdapter'

/** Extract the event type string from a CasePanelSSEEvent */
export const getEventType = (event: CasePanelSSEEvent): string =>
  event.event || (event.data?.event as string) || ''

